export enum FilterName {
    All = '__reviews_filter_all__',
    HasComment = '__reviews_filter_has_comment__',
    HasMedia = '__reviews_filter_has_media__',
    Pending = '__reviews_filter_pending__',
    Responded = '__reviews_filter_responded__',
    Unresponded = '__reviews_filter_unresponded__',
    Updated = '__reviews_filter_updated__',
    NotRespondable = '__reviews_filter_not_respondable__',
    Flagged = '__reviews_filter_flagged__',
    Unread = '__reviews_filter_unread__',
    NeedsResponse = '__reviews_filter_needs_response__',
    NoResponseRequired = '__reviews_filter_no_response_required__',
}

export interface Filter {
    label: string;
    value: FilterName;
    divider?: boolean;
}
